import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "author" }
const _hoisted_3 = { class: "bubble-container" }
const _hoisted_4 = { class: "absolute-top-right" }
const _hoisted_5 = { class: "row full-width content text-body2 text-wrap" }
const _hoisted_6 = { class: "column base-margin-top full-width author text-caption text-right text-grey" }

import { usePermissions } from 'SharedDir/common/composables/usePermissions';
import { computed } from 'vue';
import { convertUTCToLocal } from '@packages/toolbox/dist/utils/datetime';
import { Chats } from 'SharedDir/declarations/chats';
import { WithRelations } from 'SharedDir/declarations/shared';
import MessageAttachments from 'SharedDir/modules/Chats/MessageAttachments.vue';
import { useUserStore } from 'SharedDir/stores/user.store';

import ChatMessage = Chats.ChatMessage;


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'Message' },
  __name: 'Message',
  props: {
    message: {},
    dense: { type: Boolean, default: false }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;
const userStore = useUserStore();

const { can, permissionSet: set } = usePermissions();

const isItMe = computed(() => props.message.userId === userStore.user?.id);

const author = computed(() => {
  const { lastName: f, firstName: i, middleName: o } = props.message.user;
  return [f, i, o].filter((word) => word).join(' ');
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-item", {
      me: isItMe.value,
      dense: _ctx.dense,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(author.value), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["s-message-bubble", {
            dense: _ctx.dense,
          }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            (isItMe.value && _unref(can)(_unref(set).chat.delete))
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  size: "xs",
                  round: "",
                  flat: "",
                  color: "primary",
                  icon: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
                }))
              : _createCommentVNode("", true)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row full-width text-subtitle1 relative-position" }, null, -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.message.message), 1),
          (_ctx.message.attachments.length > 0)
            ? (_openBlock(), _createBlock(MessageAttachments, {
                key: 0,
                "model-value": _ctx.message.attachments,
                "no-gallery": _ctx.dense,
                readonly: ""
              }, null, 8, ["model-value", "no-gallery"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(convertUTCToLocal)(_ctx.message.createdAt).toLocaleString()), 1)
        ], 2)
      ])
    ])
  ], 2))
}
}

})